import angular from 'angular';
import get from 'lodash/get';
import merge from 'lodash/merge';
import accountBlockedTpl from 'auth/components/login-form/views/account-blocked-modal.html';
import accountBlockedCtrl from 'auth/components/login-form/account-blocked-modal';
import alertModalTpl from '../views/alert-modal.html';

export default angular.module('auth-errorcodes', []).run([
  'gettextCatalog',
  'appFactory',
  function errorCodes(gettextCatalog, appFactory) {
    appFactory.deps.config.errorCodes = merge(appFactory.deps.config.errorCodes, {
      auth: {
        '-1': (params) => ({
          body: gettextCatalog.getString('Unexpected server error. Please try again later or call {{ contactPhone }} for assistance.', {
            contactPhone: params.contactPhone,
          }),
        }),
        PASSWORD_ALREADY_USED: () => ({
          title: gettextCatalog.getString('Cannot reuse password'),
          body: gettextCatalog.getString("Cannot reuse old password. Last 3 passwords mustn't repeat."),
          template: alertModalTpl,
        }),
        ACCOUNT_NOT_FOUND: () => ({ title: gettextCatalog.getString('Account not found. Please contact the Lottery.') }),
        INVALID_USER_STATUS: () => ({ title: gettextCatalog.getString('Incorrect operation. Please contact the Lottery.') }),
        USER_NOT_FOUND: () => ({ title: gettextCatalog.getString('User not found.') }),
        BAD_CREDENTIALS: () => ({ title: gettextCatalog.getString('Incorrect credentials. Please try again.') }),
        PRIMARY_USER_NOT_EXISTS: () => ({ title: gettextCatalog.getString('Login not permitted. There is no primary user for this retailer, please contact an admin at the lottery for further assistance.') }),
        USER_ALREADY_ACTIVATED: () => ({
          title: gettextCatalog.getString('User Account is already activated. Please login with your credentials.'),
        }),
        '2FA_NO_DEVICES': (params) => ({
          component: 'setupTwoFactorDialog',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            credentials: () => get(params, 'payload.resourceOwnerCredentials', { username: '' }),
          },
        }),
        '2FA_NO_TRUSTED': (params) => ({
          component: 'confirmTwoFactorDialog',
          backdrop: 'static',
          resolve: {
            credentials: () => get(params, 'payload.resourceOwnerCredentials', { username: '' }),
          },
        }),
        ACCOUNT_SUSPENDED_MAX_LOGIN_FAILED: (params) => ({
          title: gettextCatalog.getString('Account suspended!'),
          body: gettextCatalog.getString(
            'Account has been suspended due to exceeded number of failed login attempts. Please call {{ contactPhone }} for assistance.',
            { contactPhone: params.contactPhone }
          ),
          template: alertModalTpl,
        }),
        ACCOUNT_SUSPENDED: (params) => ({
          title: gettextCatalog.getString('Account has been suspended. Please call {{ contactPhone }} for assistance.', {
            contactPhone: params.contactPhone,
          }),
        }),
        ACCOUNT_LOCKED: (params) => ({
          template: accountBlockedTpl,
          controller: accountBlockedCtrl,
          resolve: {
            model: () => appFactory.model,
          },
        }),
        USER_NOT_REGISTERED: () => ({
          title: gettextCatalog.getString(
            'You have not completed registration. Please use link sent in the e-mail while registering to complete the process.'
          ),
        }),
        MAX_CHALLENGE_ANSWER_EXCEEDED: (params) => ({
          title: gettextCatalog.getString(
            'Sorry, you have exceeded the maximum number of Forgot Password attempts. Please call {{ contactPhone }} for assistance.',
            { contactPhone: params.contactPhone }
          ),
        }),
        WRONG_CHALLENGE_ANSWER: () => ({
          title: gettextCatalog.getString(
            'Your answer does not match the answer you provided previously Please try again or select a different question.'
          ),
        }),
        NON_UNIQUE_USER_FOUND: (params) => ({
          title: gettextCatalog.getString(
            'Phone number was provided by more than one user. Please call {{ contactPhone }} for assistance.',
            { contactPhone: params.contactPhone }
          ),
        }),
        BAD_CREDENTIALS_LAST_TRY: () => ({ title: gettextCatalog.getString('Incorrect credentials. Last attempt left.') }),
        USER_ACCESS_NOT_ALLOWED: () => ({ title: gettextCatalog.getString('User is not allowed to access this application.') }),
        NOT_ASSIGNED_LOTTERY_REPRESENTATIVE: () => ({
          title: gettextCatalog.getString(
            'You are not allowed to perform this action as this user does not belong to one of your Retailers.'
          ),
        }),
        USER_DID_NOT_ACCEPT_TERMS_OF_USE: () => ({
          component: 'rwTermsOfUseDialog',
        }),
        RETAILER_ACCESS_NOT_ALLOWED: (params) => ({
          title: gettextCatalog.getString('Retailer access not allowed. Please call {{ contactPhone }} for assistance.', {
            contactPhone: params.contactPhone,
          }),
        }),
        /// {{ active }} is Lottery term using to determine User status.
        ACCOUNT_NOT_ACTIVE: (params) => ({
          title: gettextCatalog.getString('Account is not {{ active }}. Please call {{ contactPhone }} for assistance.', {
            contactPhone: params.contactPhone,
            active: params.terms.ACTIVE.singular,
          }),
        }),
        CAPTCHA_NOT_FOUND: () => ({ title: gettextCatalog.getString('Captcha not found. Please reload captcha.') }),
        INVALID_REGISTRATION_LINK: () => ({
          title: gettextCatalog.getString('The link is invalid. Please contact Administrator to request a new one.'),
        }),
      },
      forgotPassword: {
        PASSWORD_ALREADY_USED: () => ({
          title: gettextCatalog.getString('Cannot reuse password'),
          body: gettextCatalog.getString("Cannot reuse old password. Last 3 passwords mustn't repeat."),
          template: alertModalTpl,
        }),
        USER_NOT_FOUND: () => ({
          title: gettextCatalog.getString(
            'Email not recognized. Please make sure you entered it correctly or Sign Up if you have not registered.'
          ),
        }),
        ACCOUNT_LOCKED: (params) => ({
          title: gettextCatalog.getString(
            'Sorry, you cannot reset your password because your account is suspended. Please call {{ contactPhone }} for assistance.',
            { contactPhone: params.contactPhone }
          ),
        }),
        MAX_CHALLENGE_ANSWER_EXCEEDED: (params) => ({
          title: gettextCatalog.getString(
            'You have exceeded the maximum number of forgot password attempts. Please wait 30 minutes and try again. Please call {{ contactPhone }} for assistance.',
            { contactPhone: params.contactPhone }
          ),
        }),
        WRONG_CHALLENGE_ANSWER: () => ({
          title: gettextCatalog.getString(
            'Your answer does not match the answer you provided previously Please try again or select a different question.'
          ),
        }),
        USER_NOT_REGISTERED: () => ({
          title: gettextCatalog.getString(
            'You have not completed registration. Please use link sent in the e-mail while registering to complete the process.'
          ),
        }),
      },
      forgotUsername: {
        USER_NOT_FOUND: () => ({
          title: gettextCatalog.getString(
            'Phone number was not found. Please enter mobile phone number that you provided upon registration or in Retailer Wizard’s account settings.'
          ),
        }),
        NON_UNIQUE_USER_FOUND: (params) => ({
          title: gettextCatalog.getString(
            'Phone number was provided by more than one user. Please call {{ contactPhone }} for assistance',
            { contactPhone: params.contactPhone }
          ),
        }),
      },
      twoFactor: {
        '2FA_CODE_BLOCKED': (params) => ({
          title: gettextCatalog.getString('Account suspended!'),
          body: gettextCatalog.getString(
            'Account has been suspended due to exceeded number of failed login attempts. Please call {{ contactPhone }} for assistance.',
            { contactPhone: params.contactPhone }
          ),
          template: alertModalTpl,
        }),
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/auth/config/errorcodes.conf.js